import React from 'react';

export function GrayIconBox({ children, size = 44 }) {
  return (
    <span
      className="wq-gray-icon-box"
      style={{
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F2F4F6',
        borderRadius: 12,
        color: '#4E5968',
        flexShrink: 0,
      }}
      aria-hidden="true"
    >
      {children}
    </span>
  );
}

export function StrokeSvg({ children, size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export const StrokeIcons = {
  lightbulb: (
    <StrokeSvg>
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z" />
    </StrokeSvg>
  ),
  crayon: (
    <StrokeSvg>
      <path d="M12 19l7-7 3 3-7 7H8v-3z" />
      <path d="M18 8l-5-5-10 10v5h5z" />
    </StrokeSvg>
  ),
  chart: (
    <StrokeSvg>
      <path d="M4 19h16" />
      <path d="M7 16V10" />
      <path d="M12 16V6" />
      <path d="M17 16v-8" />
    </StrokeSvg>
  ),
  image: (
    <StrokeSvg>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8.5" cy="10" r="1.5" />
      <path d="M21 16l-5-5-4 4-2-2-5 5" />
    </StrokeSvg>
  ),
  cards: (
    <StrokeSvg>
      <rect x="5" y="4" width="12" height="16" rx="2" />
      <path d="M9 8h4" />
      <path d="M9 12h4" />
    </StrokeSvg>
  ),
  camera: (
    <StrokeSvg>
      <path d="M4 8h3l1.5-2h7L17 8h3v11H4z" />
      <circle cx="12" cy="13" r="3.5" />
    </StrokeSvg>
  ),
  book: (
    <StrokeSvg>
      <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
      <path d="M6 3v16" />
    </StrokeSvg>
  ),
  note: (
    <StrokeSvg>
      <path d="M8 3h7l5 5v13H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M15 3v6h6" />
      <path d="M10 13h6" />
      <path d="M10 17h4" />
    </StrokeSvg>
  ),
  printer: (
    <StrokeSvg>
      <path d="M6 9V3h12v6" />
      <path d="M6 17H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" />
      <rect x="6" y="13" width="12" height="8" rx="1" />
    </StrokeSvg>
  ),
  palette: (
    <StrokeSvg>
      <path d="M12 3a9 9 0 1 0 0 18h1.5a2.5 2.5 0 0 0 0-5H12" />
      <circle cx="7.5" cy="10" r="1" />
      <circle cx="10" cy="7.5" r="1" />
      <circle cx="14" cy="7.5" r="1" />
      <circle cx="16.5" cy="10" r="1" />
    </StrokeSvg>
  ),
  check: (
    <StrokeSvg>
      <path d="M20 6L9 17l-5-5" />
    </StrokeSvg>
  ),
  clipboard: (
    <StrokeSvg>
      <rect x="6" y="4" width="12" height="16" rx="2" />
      <path d="M9 4V3h6v1" />
      <path d="M9 10h6" />
      <path d="M9 14h4" />
    </StrokeSvg>
  ),
  lock: (
    <StrokeSvg>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </StrokeSvg>
  ),
  users: (
    <StrokeSvg>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="3" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 4.13a4 4 0 0 1 0 7.75" />
    </StrokeSvg>
  ),
  building: (
    <StrokeSvg>
      <path d="M4 21V7l8-4 8 4v14" />
      <path d="M9 21v-6h6v6" />
      <path d="M9 10h.01" />
      <path d="M15 10h.01" />
    </StrokeSvg>
  ),
  flask: (
    <StrokeSvg>
      <path d="M9 3h6" />
      <path d="M10 3v6L5 18a2 2 0 0 0 1.7 3h10.6A2 2 0 0 0 19 18l-5-9V3" />
    </StrokeSvg>
  ),
  handshake: (
    <StrokeSvg>
      <path d="M8 13l3 3 7-7" />
      <path d="M3 12l5 5 2-2" />
      <path d="M14 8l3-3 4 4-3 3" />
    </StrokeSvg>
  ),
  shield: (
    <StrokeSvg>
      <path d="M12 3l8 4v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" />
    </StrokeSvg>
  ),
  accessibility: (
    <StrokeSvg>
      <circle cx="12" cy="5" r="2" />
      <path d="M6 9h12" />
      <path d="M12 9v5" />
      <path d="M8 21l4-7 4 7" />
    </StrokeSvg>
  ),
  spark: (
    <StrokeSvg>
      <rect x="4" y="8" width="10" height="10" rx="2" />
      <path d="M16 6l1.5 3L21 10.5 17.5 12 16 15l-1.5-3L11 10.5 14.5 9z" />
    </StrokeSvg>
  ),
  search: (
    <StrokeSvg>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </StrokeSvg>
  ),
  chat: (
    <StrokeSvg>
      <path d="M21 12a8 8 0 0 1-8 8H7l-4 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 5z" />
    </StrokeSvg>
  ),
  file: (
    <StrokeSvg>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
    </StrokeSvg>
  ),
  scale: (
    <StrokeSvg>
      <path d="M12 3v18" />
      <path d="M5 8h14" />
      <path d="M5 8l-3 6h6z" />
      <path d="M19 8l-3 6h6z" />
    </StrokeSvg>
  ),
  target: (
    <StrokeSvg>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1" />
    </StrokeSvg>
  ),
  clock: (
    <StrokeSvg>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5l3 2" />
    </StrokeSvg>
  ),
  frown: (
    <StrokeSvg>
      <circle cx="12" cy="12" r="8" />
      <path d="M8 10h.01" />
      <path d="M16 10h.01" />
      <path d="M8.5 16s1.5-2 3.5-2 3.5 2 3.5 2" />
    </StrokeSvg>
  ),
  dizzy: (
    <StrokeSvg>
      <circle cx="12" cy="12" r="8" />
      <path d="M8.5 9.5l2 2-2 2" />
      <path d="M15.5 9.5l-2 2 2 2" />
      <path d="M9 16h6" />
    </StrokeSvg>
  ),
  zap: (
    <StrokeSvg>
      <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
    </StrokeSvg>
  ),
  down: (
    <StrokeSvg>
      <path d="M12 5v14" />
      <path d="M19 12l-7 7-7-7" />
    </StrokeSvg>
  ),
  document: (
    <StrokeSvg>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M8 13h8" />
      <path d="M8 17h5" />
    </StrokeSvg>
  ),
};

export function NamedGrayIcon({ name, boxSize = 44 }) {
  return <GrayIconBox size={boxSize}>{StrokeIcons[name]}</GrayIconBox>;
}

export default GrayIconBox;
